var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},_vm._l((_vm.albums),function(album){return _c('div',{key:album.id_album,staticClass:"col-3 mb-3"},[_c('Album',{attrs:{"album":album}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }